import { FeatureFlagConfig } from "@fidelix/fx-miranda";
import { AppEnv } from "../utils/consts";

// Name features by the actual feature, like "open-device-link" or
// "debug-menu-page". Try not to group features under generic flags as this
// makes removing and finding them hard. One flag per feature. Features should
// be removed once the feature is deemed stable and deployed to all
// environments. Exceptions are features like debug menus.
const featureConfig = {
  layout: ["dev", "localhost"],
  "graphic-categories": [],
} as const satisfies Record<string, readonly AppEnv[]>;

export const featureFlags = new FeatureFlagConfig(featureConfig);
